module.exports = __webpack_public_path__ + "static/media/Hajur.edb5b996.wav";